import {Query} from "tick-knock";
import {Building} from "@game/coregame/ecs/entities/Building";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {Spawner} from "@game/coregame/view/Spawner";

export const ActiveBuildingsQuery = new Query(
    entity => entity.has(Spawner) && (entity as Building).owner !== PlayerType.Default
);
